import { useState, type ReactNode } from 'react';
import { cn } from '@shared/utils';

interface TabsProps {
  className?: string;
  tabs: { label: string; content: ReactNode }[];
  onChange?: (idx: number) => void;
}

export const Tabs = (props: TabsProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const changeTabHandler = (idx: number) => {
    setActiveIndex(idx);
    props.onChange?.(idx);
  };

  if (!props.tabs || props.tabs.length === 0) return null;
  return (
    <div className={cn('mt-12', props.className)}>
      <div className='flex justify-center px-4 py-0 pt-3'>
        <div className='m-0 flex w-full max-w-[550px] justify-between overflow-hidden rounded-lg border border-[#272727] p-0'>
          {props.tabs.map((tab, index) => (
            <button
              key={index}
              className={cn(
                'flex h-10 flex-1 cursor-pointer items-center justify-center text-center text-sm font-light text-[#272727] hover:underline',
                activeIndex === index ? 'bg-[#272727] text-[#d7c29a]' : 'border-r border-r-[#272727] last:border-r-0',
              )}
              onClick={() => changeTabHandler(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className='mx-auto mb-15 max-w-screen p-0 px-24 max-md:px-0'>{props.tabs[activeIndex].content}</div>
    </div>
  );
};
